import React from 'react';
import { Header3 } from "ui-builder";
import EmailDomainsListBlock from "../emaildomain/EmailDomainsListBlock";
import { CurrentUserSenderEmailWidget } from "features/tasks-forms";
import useSettingsNavigator from "../settingsNavigator";
import { useAuthorizationChecker } from "authorization-scope";
import { TeamPermission } from "nekst-api";
import GmailPriorityWarning from "./GmailPriorityWarning";

function AdminView() {
  const settingsNavigator = useSettingsNavigator();

  return (
    <>
      <GmailPriorityWarning />
      <EmailDomainsListBlock title="Step 1. Domain Setup" headerSize={3} />
      <Header3>Step 2. Your Email Address</Header3>
      <CurrentUserSenderEmailWidget
        openEmailConfigurationPage={settingsNavigator.openEmailConfigurationPage}
      />
    </>
  );
}

function MemberView() {
  const settingsNavigator = useSettingsNavigator();

  return (
    <>
      <GmailPriorityWarning />
      <Header3>Your Email Address</Header3>
      <CurrentUserSenderEmailWidget
        openEmailConfigurationPage={settingsNavigator.openEmailConfigurationPage}
      />
    </>
  )
}

export default function CustomDomainWidget() {
  const { isGranted } = useAuthorizationChecker();

  if (isGranted(TeamPermission.MANAGE_EMAIL_CONFIGURATION)) {
    return <AdminView />;
  } else {
    return (
      <MemberView />
    );
  }

}
